let _ = require('lodash');

// Open menu on mobile with menu-toggle
const menuToggle = document.getElementById('menu-toggle');
const menuClose = document.getElementById('menu-close');

function closeNavigation() {
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
}

if (!_.isNil(menuToggle)) {
    menuToggle.addEventListener('click', () => {
        if (menuToggle.getAttribute('aria-expanded') === 'true') {
            closeNavigation();
        } else {
            menuToggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('menu-open');
        }
    });

    menuClose.addEventListener('click', () => {
        closeNavigation();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeNavigation();
        }
    });
}

// Mobile menu submenu's
const primaryMenu = document.getElementById('primary-menu');
const primaryMenuSubmenuParents = primaryMenu.querySelectorAll('.menu-item-has-children > a');

if (window.innerWidth < 992) {

    document.onclick = function (e) {
        closeNavigation();

    }

    document.getElementById('menu-toggle').addEventListener('click', (e) => {
        e.stopPropagation();
    })

    document.getElementById('primary-menu').addEventListener('click', (e) => {
        e.stopPropagation();
    })

    Array.from(primaryMenuSubmenuParents).forEach(subMenuParent => {
    //
        let clone = subMenuParent.parentElement.cloneNode(true);
        let cloneSubMenu = clone.getElementsByClassName('sub-menu')[0];
        clone.removeChild(cloneSubMenu);
        clone.removeAttribute('id');
    //     clone = clone.removeChild(cloneSubMenu);
        const parent = subMenuParent.parentElement;
        const subMenu = parent.querySelector('.sub-menu');
    //
    //     console.log(clone);
    //
        subMenu.prepend(clone)
    //
        // Give parents of submenu role="button" + aria-expanded="false" (accessibility)
        subMenuParent.setAttribute('role', 'button');
        subMenuParent.setAttribute('aria-expanded', 'false');

        // Open and close submenu
        subMenuParent.addEventListener('click', (e) => {
            e.preventDefault();

            if (subMenuParent.getAttribute('aria-expanded') === 'false') {
                subMenuParent.setAttribute('aria-expanded', 'true');

                return;
            }

            subMenuParent.setAttribute('aria-expanded', 'false');
        });
    });
}

// Make whole card clickable
function clickableCard() {
    let link = this.getElementsByTagName('A')[0];

    window.location.href = link;
}

let highlightedBlocks = document.getElementsByClassName('highlighted-block');

Array.from(highlightedBlocks).forEach(item => {
    let link = item.getElementsByTagName('A')[0];

    if (!_.isNil(link)) {
        item.addEventListener('click', clickableCard, false);
        item.style.cursor = 'pointer';
    }
});

let sidebarWidgets = document.querySelectorAll('#shop-sidebar > .widget');

if (!_.isEmpty(sidebarWidgets)) {
    Array.from(sidebarWidgets).forEach(widget => {
        let title = widget.querySelector('h3.widgettitle');
        widget.classList.add('active');

        title.addEventListener('click', () => {
            widget.classList.toggle('active');
        }, false);
    });
}

let filterToggle = document.querySelector('button.filter-toggle');
let shopSidebar = document.getElementById('shop-sidebar');

if (!_.isNil(filterToggle) && !_.isNil(shopSidebar)) {
    filterToggle.addEventListener('click', function () {
        filterToggle.classList.toggle('filter-active');
        shopSidebar.classList.toggle('active');
    })
}

let mostSoldCTA = document.querySelector('.custom-most-sold-products-cta');

if (!_.isNil(mostSoldCTA)) {
    let link = mostSoldCTA.getElementsByTagName('A')[0];

    if (!_.isNil(link)) {
        mostSoldCTA.addEventListener('click', clickableCard, false);
        mostSoldCTA.style.cursor = 'pointer';
    }
}

let wcProductVideo = document.querySelector('.woocommerce-product-gallery__image--video');

if (wcProductVideo) {
    let iFrame = wcProductVideo.querySelector('iframe');
    let iFrameSrc = iFrame.dataset.src;
    let videoId = iFrameSrc.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();

    setTimeout(() => {
        let galleryNavItem = document.querySelector('.flex-control-nav > li:last-child');
        let galleryNavItemThumb = galleryNavItem.querySelector('img');

        if (videoId.length !== 11) {
            return;
        }

        let galleryVideoThumbSrc = 'https://img.youtube.com/vi/' + videoId + '/0.jpg';
        galleryNavItem.classList.add('woocommerce-product-gallery__image--video__thumb');
        galleryNavItemThumb.src = galleryVideoThumbSrc;
    }, 1000);
}

let newsletterReadMoreButton = document.getElementById('read-more-newsletter-button');
let newsletterAside = document.getElementById('newsletter-aside');

newsletterReadMoreButton.addEventListener('click', (e) => {
    if (newsletterReadMoreButton.getAttribute('aria-expanded') === 'false') {
        newsletterAside.classList.add('open');
        newsletterReadMoreButton.setAttribute('aria-expanded', 'true')
        newsletterReadMoreButton.querySelector('.open-text').hidden = true;
        newsletterReadMoreButton.querySelector('.close-text').hidden = false;
        return;
    }

    if (newsletterReadMoreButton.getAttribute('aria-expanded') === 'true') {
        newsletterAside.classList.remove('open');
        newsletterReadMoreButton.setAttribute('aria-expanded', 'false')
        newsletterReadMoreButton.querySelector('.open-text').hidden = false;
        newsletterReadMoreButton.querySelector('.close-text').hidden = true;
    }
});